import React from 'react'
import { Helmet } from "react-helmet";
import { Container, Row, Col, Image, Card, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router";
import ApproachCarousel from './ApproachCarousel';
import TechBlock from '../TechBlock';
import CustomSoftwareFaq from './CustomSoftwareFaq';
import ServiceSlider from './ServiceSlider';

import gradient from "../../Assets/banner-blue-pill.png";

export default function Contact() {
    return (
        <>
            <Helmet>
                <title>Custom Software Development Services</title>

                <meta
                    name="description"
                    content="Explore Parabola IT’s custom software development services for businesses that need reliable, scalable software, enterprise-grade solutions and strong Ruby on Rails expertise."
                />

                <meta
                    name="keywords"
                    content="custom software development services, custom software development company, enterprise software solutions, software product development, bespoke software development, Ruby on Rails development"
                />

                {/* Open Graph */}
                <meta property="og:title" content="Custom Software Development Services" />
                <meta
                    property="og:description"
                    content="Reliable, scalable enterprise software solutions by Parabola IT."
                />
                <meta property="og:type" content="website" />
            </Helmet>

            <section className='bg-theme section-hero'>
                <Container className="header-section pb-5 pt-2">
                    <Breadcrumb className="custom-breadcrumb">
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item href="/service">
                            Services
                        </Breadcrumb.Item>
                        <span className="separator">›</span>
                        <Breadcrumb.Item active>Custom Software Development</Breadcrumb.Item>
                    </Breadcrumb>
                    <Row className='mb-4 pt-5'>
                        <Col md={11}>
                            <h2 className="heading-style-h2 pb-3 text-white"><span className="text-gradient-1">Custom Software Development </span>Services</h2>
                            <h5 className='heading-style-h5 pb-5 text-white'>Software structured around your processes, without getting in the way as your business evolves. </h5>
                        </Col>
                    </Row>
                    <div className="pills-wrap">

                        <div className="hero-pill-right-wrap animation_slide-up-delay-2">
                            <Image src={gradient} />
                        </div>
                    </div>
                </Container >
            </section >
            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row>
                        <Col md={7}>
                            <h2 className="heading-style-h2 pb-3">What <span className="text-gradient-1">Custom Software</span><br />Means for Your Business </h2>
                        </Col>
                        <h5 className='heading-style-h5 mb-5'>Custom software is created around specific business needs and workflows. It fits into how your teams operate, and how your systems already connect. </h5>
                        <h5 className='heading-style-h5 mb-5'>Custom software is created around specific business needs and workflows. It fits into how your teams operate, and how your systems already connect. </h5>
                        <h5 className='heading-style-h5'>At Parabola IT, we approach this with clarity and structure. The focus is on reducing complexity, improving efficiency, and building systems that hold up over time. This includes building enterprise software solutions that support complex workflows and integrations. </h5>
                    </Row>
                </Container>
            </section>
            <Container className="padding-section-large">
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">What We Offer in <span className="text-gradient-1">Custom Software Development</span></h2>
                        <h5 className='heading-style-h5 pb-5'>A complete set of services to build, extend and support software that fits your business needs and workflows. </h5>
                    </Col>
                </Row>
                <Row className="align-items-center mb-5 serviceCard bg-gradient-1 p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>

                        <div className="banner-content">
                            <h4 className='heading-style-h4'>End-to-End Application Development </h4>
                            <p className="desc">We handle the full development lifecycle, from understanding requirements through to deployment. The focus stays on building something that fits your operations from day one. </p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Requirement understanding and solution planning</span>
                                <span>Application design and development  </span>
                                <span>Deployment and release readiness</span>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Scalable Architecture Design</h4>
                            <p className="desc">Systems are structured to handle growth without becoming unstable or difficult to manage. The goal is to keep things flexible while maintaining performance. </p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Architecture planning for long-term use</span>
                                <span>Performance-focused system design  </span>
                                <span>Maintainable and adaptable code structure  </span>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row className="align-items-center mb-5 serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>System Integration and Enhancements </h4>
                            <p className="desc">Your software needs to work with the systems you already use. We focus on making those connections seamless and reliable. </p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Integration with ERP, CRM and internal systems</span>
                                <span>API development and third-party integrations</span>
                                <span>Feature enhancements for existing platforms</span>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row className="align-items-center mb-5 serviceCard p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Ongoing Support and Optimization</h4>
                            <p className="desc">Support doesn’t stop at launch. We continue improving performance, stability, and usability as your system evolves.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Performance improvements</span>
                                <span>Issue resolution and system stability  </span>
                                <span>Continuous updates and refinements</span>
                            </div>
                        </div>
                    </Col>

                </Row>

                <Row className="align-items-center serviceCard  p-4">
                    {/* LEFT CONTENT */}
                    <Col md={12}>
                        <div className="banner-content">
                            <h4 className='heading-style-h4'>Enterprise Software Solutions</h4>
                            <p className="desc">For businesses with complex workflows and multiple moving parts, systems need to stay consistent under pressure. We structure software to support that level of demand.</p>

                            {/* LINKS */}
                            <div className="banner-links text-gradient-1 mb-4">
                                <span>Performance improvements</span>
                                <span>Issue resolution and system stability</span>
                                <span>Continuous updates and refinements</span>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={10}>
                            <h2 className='heading-style-h2 pb-3'>Want to Explore What This Could Look Like? </h2>
                            <p>We’ll help you understand how the right custom software approach can take shape for your business.</p>
                        </Col>

                        {/* Right Button */}
                        <Col md={2} className="text-md-end mt-3 mt-md-0">
                            <Link to="/contact" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Let's Talk</Link>
                        </Col>

                    </Row>
                </Container>
            </section>
            <ApproachCarousel />

            <section className='padding-section-large bg-gradient-1'>
                <Container>
                    <Row className=''>
                        <Col md={9}>
                            <h2 className="heading-style-h2 pb-3">How Custom Software Helps<br /><span className="text-gradient-1">Your Business</span></h2>
                            <h5 className='heading-style-h5 pb-5'>Practical outcomes that improve how your systems perform and how your teams operate.  </h5>
                        </Col>
                    </Row>
                    <Row className="d-flex align-items-stretch stagger-wrapper">
                        <div className="stagger-grid">
                            {/* Card 1 */}
                            <div className="card-box primary-border light-bg logo-bg">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Faster rollout of systems and features</h5>
                                <p>Move from idea to usable software faster with a more structured development approach</p>
                            </div>

                            {/* Card 2 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>More efficient day-to-day operations</h5>
                                <p>Reduce manual effort and bring consistency to how tasks and workflows are handled</p>
                            </div>

                            {/* Card 3 */}
                            <div className="card-box card-2">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Better control over long-term costs</h5>
                                <p>Avoid repeated fixes and tool sprawl with systems that are easier to maintain</p>
                            </div>

                            {/* Card 4 */}
                            <div className="card-box card-moveBottom">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Supports growth without added complexity</h5>
                                <p>Handle increasing users, data and integrations without disrupting performance</p>
                            </div>

                            {/* Card 5 */}
                            <div className="card-box card-4">
                                <h5 className='heading-style-h5 mb-4 fw-bold'>Clearer structure across your systems </h5>
                                <p>Bring visibility and order to processes that are otherwise fragmented</p>
                            </div>

                        </div>
                    </Row>

                </Container>
            </section>
            <TechBlock />
            <ServiceSlider />
            <section className='bg-blue text-white py-5 blue-logo-bg'>
                <Container>
                    <Row>
                        {/* Left Text */}
                        <Col md={9}>
                            <h2 className='heading-style-h2 pb-3'>Let’s Build Something That Fits </h2>
                            <p>If you're looking for software that supports how your business runs and continues to perform as things grow, we’ll help you move forward with a clear and practical approach. </p>
                        </Col>

                        {/* Right Button */}
                        <Col md={3} className="text-md-end mt-3 mt-md-0">
                            <Link to="/about" className='btn btn-outline-light ls-10 rounded-pill text-uppercase'>Start Something That Works</Link>
                        </Col>

                    </Row>
                </Container>
            </section>
            <CustomSoftwareFaq />
        </>
    )
}
